//
//
//
//
//
//
//
//
//
//
//
//


import { mapState } from "vuex";

export default {
    name: "MultiLanguage",
    data() {
        return {
            currentLangSelected: "en"
        };
    },
    computed: {
        ...mapState("components", ["isSmallScreen"])
    },
    mounted() {
        this.currentLangSelected = localStorage.getItem("language") || "en";
    },
    methods: {
        selectLang(lang) {
            this.currentLangSelected = lang;
            this.$i18n.locale = lang;
            localStorage.setItem("language", lang);
            localStorage.setItem("changedFlag", true);
        }
    }
};
